"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fingerprintGraph = void 0;
const probes_1 = require("./probes");
const compareStrings = (left, right) => {
    if (left === right)
        return 0;
    return left < right ? -1 : 1;
};
// The DB returns artifact and dependency rows in no particular order, and some
// derived views (UI edge order → stack input order, mesh document contents)
// follow row order. Sorting first makes a fingerprint a function of the graph
// alone, so two runs against the same data always agree.
const inCanonicalOrder = (document) => ({
    ...document,
    artifacts: [...document.artifacts].sort((left, right) => compareStrings(left.id, right.id)),
    dependencies: [...document.dependencies].sort((left, right) => compareStrings(left.inputArtifactId, right.inputArtifactId) ||
        compareStrings(left.outputArtifactId, right.outputArtifactId)),
});
/**
 * Runs `probeNames` (usually `PROBE_NAMES`) against one document. A probe that throws
 * is recorded as an error result instead of aborting the others, because
 * "this graph throws here" is itself behaviour a refactor must preserve.
 */
const fingerprintGraph = (document, probeNames) => {
    const ordered = inCanonicalOrder(document);
    return Object.fromEntries(probeNames.map((name) => {
        const start = Date.now();
        try {
            const output = probes_1.probes[name].run(ordered);
            return [name, { status: 'ok', output, durationMs: Date.now() - start }];
        }
        catch (error) {
            return [
                name,
                {
                    status: 'error',
                    output: error instanceof Error ? error.message : String(error),
                    durationMs: Date.now() - start,
                },
            ];
        }
    }));
};
exports.fingerprintGraph = fingerprintGraph;
//# sourceMappingURL=fingerprint.js.map